import {
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, ReplaySubject } from 'rxjs';
import { filter, map, takeWhile, withLatestFrom } from 'rxjs/operators';
import * as fromAccounts from '../../../account/store';
import { SelectItem } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';

@Component({
    selector: 'ef-invoice-setup-filters-container',
    templateUrl: './invoice-setup-filters-container.component.html',
    styleUrls: ['./invoice-setup-filters-container.component.scss'],
    standalone: false
})
export class InvoiceSetupFiltersContainerComponent
    implements OnInit, OnDestroy {
    contracts$: Observable<fromAccounts.AccountContract[]>;
    contractsSelectItems$: Observable<SelectItem[]>;
    private SelectContractSubject = new ReplaySubject<string[]>(1);
    private active = true;
    @Output() SelectContract = new EventEmitter<
        fromAccounts.AccountContract[]
    >();
    constructor(private store: Store, private log: LoggingService) {}

    ngOnInit(): void {
        this.store.dispatch(fromAccounts.getContractARAccounts());

        this.contracts$ = this.store.pipe(
            select(fromAccounts.selectContractARAccounts),
            filter(x => !!x && x.length > 0)
            // tap(contracts => this.SelectContract.next([contracts[0]]))
        );
        this.contractsSelectItems$ = this.contracts$.pipe(
            filter(x => !!x && x.length > 0),
            map(items =>
                items.map(item => ({
                    label: item.Contractdesc,
                    value: item.Contractlistid
                }))
            )
        );

        this.SelectContractSubject.pipe(
            takeWhile(() => this.active),
            withLatestFrom(this.contracts$)
        ).subscribe(([selected, contracts]) => {
            this.log.verbose({
                type: 'InvoiceSetupFiltersContainerComponent:SelectContractSubject',
                selected,
                contracts
            });
            const selectedContract = contracts.filter(c =>
                selected.includes(c.Contractlistid)
            );
            this.SelectContract.next(selectedContract);
        });
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    onSelectContract($event: string[]) {
        this.log.verbose({
            type: 'InvoiceSetupFiltersContainerComponent:onSelectContract',
            $event
        });
        this.SelectContractSubject.next($event);
    }
}
